export default {
  state: {
    hasSeenTebaEmailPopupSinceLogin:
      localStorage.getItem('hasSeenTebaEmailPopupSinceLogin') || false,
  },
  mutations: {
    setHasSeenTebaEmailPopupSinceLogin(state, hasSeenTebaEmailPopupSinceLogin) {
      localStorage.setItem(
        'hasSeenTebaEmailPopupSinceLogin',
        hasSeenTebaEmailPopupSinceLogin
      );
      state.hasSeenTebaEmailPopupSinceLogin = hasSeenTebaEmailPopupSinceLogin;
    },
  },
  actions: {
    setHasSeenTebaEmailPopupSinceLogin(
      { commit },
      hasSeenTebaEmailPopupSinceLogin
    ) {
      commit(
        'setHasSeenTebaEmailPopupSinceLogin',
        hasSeenTebaEmailPopupSinceLogin
      );
    },
  },
  getters: {
    hasSeenTebaEmailPopupSinceLogin: state =>
      state.hasSeenTebaEmailPopupSinceLogin,
  },
};
